import Link from 'next/link';

import * as React from 'react';

import type { ISubSections } from '@/shared/actions/navigation.service';
import { SubsectionLink } from '@/shared/components/header/shared/subsection-link';
import { ImageImgix } from '@/shared/ui/media/image-imgix';

export interface IMobileSubSectionProps {
    subsectionSelected: ISubSections;
}

export function MobileSubSection({ subsectionSelected }: IMobileSubSectionProps) {
    return (
        <div className='animate-in slide-in-from-bottom flex h-full w-full flex-col gap-10 bg-white px-9 py-10 duration-200'>
            <div className='w-full'>
                <SubsectionLink
                    title={subsectionSelected.title}
                    url={subsectionSelected.internalLink || subsectionSelected.url || '#'}
                />
            </div>
            <div className='grid grid-cols-2 space-y-4'>
                {subsectionSelected.links?.map(link => (
                    <Link key={link.id} href={link.internalLink || link.url || '#'} className='my-2'>
                        {link.title}
                    </Link>
                ))}
            </div>
            <div>
                {subsectionSelected.image && (
                    <div className='flex w-full flex-col gap-8'>
                        <ImageImgix
                            {...subsectionSelected.image}
                            className='size-full object-cover'
                            imgixSizes={{
                                max: { width: 377, height: 242 },
                            }}
                        />
                        <p className='text-body-xs-400'>{subsectionSelected.description}</p>
                    </div>
                )}
            </div>
        </div>
    );
}
